import { useEffect, useRef } from 'react';
import {
  domainsInclude,
  subscribeDataChanged,
  type DataDomain,
} from '../utils/dataSync';

/**
 * Soft-refresh a mounted screen when another module completes a mutation.
 * `refresh` must be a stable useCallback. Does not remount the page.
 */
export function useDataSyncRefresh(
  wanted: readonly DataDomain[],
  refresh: () => void,
  delayMs = 80
): void {
  const wantedRef = useRef(wanted);
  wantedRef.current = wanted;

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | null = null;
    const unsub = subscribeDataChanged((detail) => {
      if (!domainsInclude(detail.domains, ...wantedRef.current)) return;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => refresh(), delayMs);
    });
    return () => {
      unsub();
      if (timer) clearTimeout(timer);
    };
  }, [refresh, delayMs]);
}
